<template>
  <v-container fluid fill-height class="pa-0">
    <v-row class="fill-height flex-column">
      <v-col class="flex-shrink-1 flex-grow-0 pt-0 pr-0 pb-0">
        <v-toolbar flat>
          <v-btn
            :outlined="!(region === 'oulu')"
            depressed
            color="primary"
            @click="fetchCalls('oulu')"
            class="mr-4"
          >
            OULU
          </v-btn>
          <v-btn
            :outlined="!(region === 'vantaa')"
            depressed
            color="primary"
            @click="fetchCalls('vantaa')"
            class="mr-4"
          >
            VANTAA
          </v-btn>
          <v-btn
            :outlined="!(region === 'finwe')"
            depressed
            color="primary"
            @click="fetchCalls('finwe')"
          >
            Finwe
          </v-btn>
        </v-toolbar>
        <v-progress-linear
          v-if="state === 'LOADING'"
          indeterminate
          color="yellow darken-2"
        ></v-progress-linear>
      </v-col>
      <v-col>
        <v-row>
          <v-col v-if="state === 'ERROR'">
            <span class="red--text">{{error}}</span>
          </v-col>
          <v-col v-else-if="weekly" class="flex-shrink-0 flex-grow-1 pt-0">
            <v-row>
              <v-col cols=1 class="flex-shrink-1 flex-grow-0 pt-0 pr-0 pb-0">
                <v-list>
                  <v-list-item-group v-model="model">
                  <v-list-item
                    v-for="item in weekly"
                    :key="item.id"
                    @click="weekId = item.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="text-center">{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols=11 class="flex-shrink-0 flex-grow-1 pt-0 pl-0">
                <v-expansion-panels v-model="selectedCallId">
                  <v-expansion-panel
                    v-for="item in weeklyCalls"
                    :key="item.call_id"
                    @change="changed(item.call_id)"
                  >
                    <v-expansion-panel-header>
                      {{item.timestamp}}
                      <template v-if="item.duration">
                        puhelun kesto: {{durationText(item.duration)}}
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <VideocallContent
                        :key="item.call_id"
                        :region="region"
                        :callId="item.call_id"/>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VideocallContent from '@/components/Videocalls/VideocallContent.vue';
import { idToken } from '@/utils/auth';
import EventBus from '@/utils/EventBus';

export default {
  name: 'Videocalls',
  data() {
    return {
      model: null,
      weekId: null,
      state: '',
      selectedWeek: null,
      region: null,
      videocalls: null,
      selectedCallId: null,
      options: {
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: 'Europe/Helsinki',
      },
    };
  },
  components: {
    VideocallContent,
  },
  computed: {
    weeklyCalls() {
      if (this.weekId && this.weekly) {
        const arr = this.weekly.filter((el) => el.id === this.weekId);
        return arr.length > 0 ? arr[0].children : [];
      }
      return [];
    },
    weekly() {
      if (this.videocalls) {
        const calls = this.videocalls.map(({ incall, hangup, ...rest }) => (
          {
            ...((hangup && incall)
            && { duration: parseInt((new Date(hangup) - new Date(incall)) / 1000, 10) }),
            ...rest,
          }
        ));
        const data = calls.map(({ timestamp, ...rest }) => ({ week: this.getWeekNumber(new Date(timestamp)), timestamp: new Intl.DateTimeFormat('fi-FI', this.options).format(new Date(timestamp)), ...rest }));

        const weekJson = data.reduce((r, o) => {
          const k = o.week;
          // eslint-disable-next-line
          if (r[k] || (r[k] = [])) r[k].push(o);
          return r;
        }, {});
        console.log(weekJson);
        const weekArr = [];
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(weekJson)) {
          // console.log(`${key}: ${value}`);
          weekArr.push({
            id: key,
            name: key,
            children: value,
          });
        }
        console.log(weekArr);
        const sorted = weekArr.sort((a, b) => (b.id - a.id));
        return sorted;
      }
      return null;
    },
    formattedVideoCalls() {
      if (this.videocalls) {
        const calls = this.videocalls.map(({ incall, hangup, ...rest }) => (
          {
            ...((hangup && incall)
            && { duration: parseInt((new Date(hangup) - new Date(incall)) / 1000, 10) }),
            ...rest,
          }
        ));
        return calls.map(({ timestamp, ...rest }) => ({ timestamp: new Intl.DateTimeFormat('fi-FI', this.options).format(new Date(timestamp)), ...rest }));
      }
      return null;
    },
  },
  methods: {
    durationText(data) {
      let seconds = data;
      let minutes = Math.floor(seconds / 60);
      let hours = '';
      if (minutes > 59) {
        hours = Math.floor(minutes / 60);
        hours = (hours >= 10) ? hours : `0${hours}`;
        minutes -= (hours * 60);
        minutes = (minutes >= 10) ? minutes : `0${minutes}`;
      }

      seconds = Math.floor(seconds % 60);
      seconds = (seconds >= 10) ? seconds : `0${seconds}`;
      if (hours !== '') {
        return `${hours}:${minutes}:${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },

    changed(id) {
      console.log(`changed ${id}`);
      EventBus.$emit('callId-changed', id);
    },
    async fetchCalls(region) {
      this.videocalls = null;
      this.state = 'LOADING';
      this.region = region;
      try {
        const token = await idToken();
        const response = await fetch(`https://rest.boom.livesynccloud.com/api/videocalls/${this.region}`, {
          method: 'get',
          mode: 'cors',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // Check HTTP status
        if (!response.ok) {
          this.state = 'ERROR';
          this.error = `Puheluiden haku epäonnistui: ${this.region}`;
          return;
        }
        this.state = null;
        this.error = null;

        const ids = await response.json();
        this.videocalls = ids.sort((a, b) => (new Date(b.timestamp) - new Date(a.timestamp)));
      } catch (error) {
        console.log(error);
        this.state = 'ERROR';
        this.error = `Puheluiden haku epäonnistui: ${this.region}`;
        this.videocalls = null;
      }
    },
    getWeekNumber(ts) {
      const d = new Date(Date.UTC(ts.getFullYear(), ts.getMonth(), ts.getDate()));
      const dayNum = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      return `${ts.getFullYear()}-${(Math.ceil((((d - yearStart) / 86400000) + 1) / 7)).toString().padStart(2, '0')}`;
    },
  },
};
</script>

<style scoped>
.highlighted {
  color: aqua;
}

.bg-color {
  background-color: white;
}
</style>
